import styled from 'styled-components';

export const Wrapper = styled.div`
  display: grid;
  justify-content: center;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 24px;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.mediaQueries.xs}) {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }
`;
